import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'breadcrumbTranslate' })
export class BreadcrumbTranslatePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string): string {
    return this.translate.instant(`breadcrumbs.${value}`);
  }
}